require('./bootstrap');

import Alpine from 'alpinejs'
import money from 'alpinejs-money'
import Tooltip from "@ryangjchandler/alpine-tooltip";
 
window.Alpine = Alpine

Alpine.plugin(money)

 
Alpine.start()